<template>
	<div class="header">
		<div class="logo">
			<img src="../../static/img/chef-logo.png" alt="" srcset="">
		</div>
		<div class="menu-items">
				<ul>
					<li @click="changeRoute('/Home')">
						<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-house-icon lucide-house"><path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path><path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path></svg>
						<span class="menu-text">דף הבית</span>
					</li>
					<li @click="changeRoute('/ordersBeta')">
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-bag-icon lucide-shopping-bag"><path d="M16 10a4 4 0 0 1-8 0"/><path d="M3.103 6.034h17.794"/><path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"/></svg>						<span class="menu-text">הזמנות</span>
					</li>
					<li @click="changeRoute('/Inventory')">
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-boxes-icon lucide-boxes"><path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"/><path d="m7 16.5-4.74-2.85"/><path d="m7 16.5 5-3"/><path d="M7 16.5v5.17"/><path d="M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"/><path d="m17 16.5-5-3"/><path d="m17 16.5 4.74-2.85"/><path d="M17 16.5v5.17"/><path d="M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"/><path d="M12 8 7.26 5.15"/><path d="m12 8 4.74-2.85"/><path d="M12 13.5V8"/></svg>						<span class="menu-text">מלאי</span>
					</li>
          
					<!-- <div class="admin-btn" v-if="$root.loggedUser.Type == 'Admin'">
						<span class="menu-text">כלי מנהל</span>
						<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>
						<div class="admin-actions">
							<ul>
								<li>משתמשים</li>
								<li>מתכונים</li>
								<li>ספקים</li>
								<li>שיקים</li>
								<li>הוצאות</li>
								<li>מחירון</li>
							</ul>
						</div>
					</div> -->
<li class="admin-btn" v-if="$root.loggedUser.Type === 'Admin'">
  <button class="menu__btn" @click="isActive = !isActive" type="button">כלי מנהל</button>

  <!-- مهم: @click.stop حتى ما يتسكر الصندوق عند الضغط داخله -->
  <ul class="menu__list menu__list--wide" dir="rtl" :class="{ 'is-open': isActive }" @click.stop>

    <!-- الأزرار الملوّنة داخل الصندوق -->
    <div class="quick-actions">
 <button
  v-for="(btn, i) in quickLinks"
  :key="i"
  class="qa-btn"
  :style="{
    backgroundColor: btn.color || '#3B82F6',
    color: btn.textColor || '#fff'
  }"
  @click="handleQuickAction(btn)"
>
  {{ btn.label }}
</button>

</div>

    <hr class="menu-divider" />

    <!-- عناصر القائمة العادية تحت الأزرار -->
    <li><span @click="changeRoute('/');  isActive=false">משתמשים</span></li>
    <li><span @click="changeRoute('/Secret');  isActive=false" >מתכונים</span></li>
    <li><span @click="changeRoute('/Suppliers');  isActive=false">ספקים</span></li>
    <li><span @click="changeRoute('/cheques');   isActive=false">שיקים</span></li>
    <li><span @click="changeRoute('/reports');   isActive=false">סיכום חודשי</span></li>
	  <li><span @click="changeRoute('/');   isActive=false">ניהול קישורים חיצוניים</span></li>
  </ul>
</li>


					
					
				</ul>
		</div>
		<!-- <div class="buttons">
			<div class="addNewBtn" @click="addNewOpen()"  ref="addNewDropDown" >
				<button > חדש + </button>
				<div class="NewDropDown" v-if="addNew"  >
                        <ul>
                            <router-link  to="/newOrderBeta" class="link"><li> <i class="material-icons">add</i> הזמנה חדשה</li></router-link>
                            <li @click="openModal()" > <i class="material-icons">add</i> ספק חדש</li>
                            <li @click="openExpenseModal()"> <i class="material-icons">add</i>מתכון חדש</li>
                            <li @click="openChequeModal()"> <i class="material-icons">add</i> שיק חדש</li>
                        </ul>
                    </div>
			</div>
			
		</div> -->
    <!-- زر القائمة للموبايل -->
<!-- زر القائمة للموبايل -->
<button class="menu-toggle" @click="mobileMenuOpen = !mobileMenuOpen">
  ☰
</button>

<!-- قائمة الجوال -->
<div class="mobile-menu" v-if="mobileMenuOpen">
  <ul>
    <li @click="navigateAndClose('/Home')">דף הבית</li>
    <li @click="navigateAndClose('/ordersBeta')">הזמנות</li>
    <li @click="navigateAndClose('/Inventory')">מלאי</li>

    <!-- כלי מנהל -->
    <li class="mobile-submenu">
      <div class="submenu-title">כלי מנהל</div>
      <div class="quick-actions-mobile">
        <button
          v-for="(btn, i) in quickLinks"
          :key="i"
          class="qa-btn"
          :style="{ backgroundColor: btn.color || '#3B82F6', color: btn.textColor || '#fff' }"
          @click="handleQuickAction(btn)"
        >
          {{ btn.label }}
        </button>
      </div>
      <ul>
        <li @click="navigateAndClose('/')">משתמשים</li>
        <li @click="navigateAndClose('/Secret')">מתכונים</li>
        <li @click="navigateAndClose('/Suppliers')">ספקים</li>
        <li @click="navigateAndClose('/cheques')">שיקים</li>
        <li @click="navigateAndClose('/')">ניהול קישורים</li>
      </ul>
    </li>

    <li @click="goToSettings">⚙️ הגדרות</li>
    <li class="logout" @click="logout">🔴 התנתקות</li>
  </ul>
</div>

		<div class="buttons">
  <!-- زر "חדש +" -->
  <div class="addNewBtn" @click="addNewOpen()" ref="addNewDropDown">
    <button>חדש +</button>
    <div class="NewDropDown" v-show="addNew">
  <ul>
    <router-link to="/newOrderBeta" class="link">
      <li><i class="material-icons">add</i> הזמנה חדשה</li>
    </router-link>

    <li @click="emitOpen('supplier')"><i class="material-icons">add</i> ספק חדש</li>
    <li @click="emitOpen('recipe')"><i class="material-icons">add</i> מתכון חדש</li>
    <li @click="emitOpen('cheque')"><i class="material-icons">add</i> שיק חדש</li>
  </ul>
</div>

  </div>

  <!-- زر اليوزر -->
  <div class="user-dropdown" @click.stop="userMenuOpen = !userMenuOpen">
    <button class="user-btn">
      <img :src="$root.loggedUser.profileImg" class="user-avatar" alt="User" />
      <span class="user-name">{{ $root.loggedUser.firstName }}</span>
      <span class="chevron">&#9662;</span>
    </button>
    <ul v-if="userMenuOpen" class="user-menu">
      <li @click="goToSettings">⚙️ הגדרות</li>
      <li class="logout" @click="logout">🔴 התנתקות</li>
    </ul>
  </div>
</div>

	</div>
</template>

<script>
import firebase from "firebase/app";
import { ref } from 'vue';
export default {
	data () {
    return {
		isActive: false,
		extActive: false,
		addNew: false,
		pageName:null,
		userMenuOpen: false,
		quickLinks: [],
    mobileMenuOpen: false,

    }
  },

   mounted(){
    document.addEventListener('click', this.onClickOutside);
	document.addEventListener("click", this.closeMenus);

	const db = firebase.firestore();
		db.collection("AdminQuickLinks").doc("externalLinks").get()
			.then(doc => {
			if (doc.exists) {
				this.quickLinks = doc.data().buttons || [];
			}
			})
			.catch(err => {
			console.error("Error fetching quick links:", err);
			});
		},
  beforeDestroy(){
    document.removeEventListener('click', this.onClickOutside);
	document.removeEventListener("click", this.closeMenus);

  },
  methods:{
      navigateAndClose(route) {
    this.mobileMenuOpen = false;
    this.$router.push(route);
  },
  emitOpen(type){
    // ببعث للـApp
    this.$emit('open-modal', type)
    // (اختياري) سكّر الدروب داون بعد الضغط
    this.addNew = false
  },
	onClickOutside(e){
      // إذا الضغط مش داخل عنصر .admin-btn -> سكّر القائمة
      const btn = this.$el.querySelector('.admin-btn');
      if (btn && !btn.contains(e.target)) this.isActive = false;
    },
	toggle(){
        
		if (!this.isActive) {
		this.isActive = true;
		} else {
			this.isActive = false;
		}

    },
    logout(){
          // console.log("Logout Click");
          let vm = this;
          localStorage.removeItem("User");
          vm.$root.loggedUser = null;
          vm.$router.replace("/");
        },

	goToSettings() {
		this.userMenuOpen = false;
		this.$router.push('/settings');
  	},
	addNewOpen(){
        if (!this.addNew) {
		this.addNew = true;
        this.dropOpen = false;
		} else {
			this.addNew = false;
		}
    },
	changeRoute(pageName){
		if(pageName != this.$route.path){
			this.$router.push(pageName);
		}
		this.isActive = false;
	},
	 closeMenus(e) {
    // إغلاق القوائم إذا كبس براهم
    if (!this.$el.querySelector(".user-dropdown").contains(e.target)) {
      this.userMenuOpen = false;
    }
    if (!this.$el.querySelector(".addNewBtn").contains(e.target)) {
      this.addNew = false;
    }
  },
	handleQuickAction(btn) {
  this.isActive = false;

  if (btn.action.startsWith("/")) {
    // رابط داخلي
    this.$router.push(btn.action);
  } else {
    // رابط خارجي
    let url = btn.action;
    if (!/^https?:\/\//i.test(url)) {
      url = "https://" + url;
    }
    window.open(url, "_blank");
  }
}

  }
}
</script>

<style  scoped>
.header{
  width:100%;
  height:75px;
  padding:0 1rem;
  background:#014342;
  display:flex;
  align-items:center;
  justify-content:space-between;
  position:relative;
  z-index:5;                   /* فوق محتوى الصفحة */
}

/* الشعار */
.logo{ width:20%; overflow:hidden; }
.logo img{ width:200px; }

/* وسط: عناصر الملاحة */
.menu-items{
  width:60%;
  height:100%;
  display:flex;
  align-items:center;
  justify-content:center;
}

/* ال UL العلوي فقط */
.menu-items > ul{
  margin:0; padding:0;
  height:75px; width:100%;
  display:flex; align-items:center;
  gap:8px;
  overflow:visible;            /* اسمح للـ dropdown يطلع */
}

/* عناصر المستوى الأول فقط */
.menu-items > ul > li{
  color:#fff;
  padding:0 10px;
  font-size:14px;
  line-height:73px;            /* مثل ارتفاع الشريط */
  cursor:pointer;
  display:inline-block;
  position:relative;
  white-space:nowrap;
}

.menu-items > ul > li:hover{
  border-bottom:2px solid #76e6b6;
}

.menu-text{ margin-inline-start:8px; }
.menu-items > ul > li:last-child:hover{ border-bottom:0; }

/* زر فتح قائمة الأدمن */
.admin-btn{ position:relative; }
.menu__btn{
  background:transparent; border:0; color:#fff; cursor:pointer;
  line-height:73px; font-size:14px; padding:0 6px;
}
.menu-items > ul > li > .badge{
  background-color: #ffd966;
  color: #000;
}
/* الـ DROPDOWN نفسه */
.menu__list{
  position:absolute;
  inset-inline-end:0;          /* يمين للـ RTL */
  top:100%;
  min-width:220px;

  margin:8px 0 0;
  padding:8px 0;

  background:#fff;
  border:1px solid #E6E8EB;
  border-radius:12px;
  box-shadow:0 8px 24px rgba(16,24,40,.12);

  display:block;               /* مهم: مش flex */
  height:auto; max-height:none;
  overflow:visible;

  opacity:0; visibility:hidden; transform:translateY(6px);
  transition:.18s ease;
  z-index:1000;
}
.menu__list.menu__list--wide{
  min-width: 640px;         /* عدّلها إذا بدك صفين بدل 4 أعمدة */
  padding: 12px;            /* padding أكبر شوي لأنه فيه أزرار */
}
/* شبكة الأزرار */
.quick-actions{
  display: grid;
  grid-template-columns: repeat(4, minmax(130px, 1fr)); /* 4 أزرار بالصف */
  gap: 10px;
  margin-bottom: 8px;
}
.menu__list.is-open{
  opacity:1; visibility:visible; transform:translateY(0);
}

/* عناصر داخل القائمة المنسدلة */
.menu__list li{ list-style:none; line-height:1.4; }
.menu__list span{
	display:block;
	padding:10px 14px;
	text-decoration:none;
	color:#0F172A;
	white-space:nowrap;
	font-size: 14px;
	font-weight: 500;
}
.menu__list span:hover{ background:#F8FAFC; }
  .menu-toggle{
    display: none;
  }
/* أزرار اليمين */
.buttons{ width:20%; display:flex; justify-content:flex-end; }
.buttons button{
  display: flex;
  align-items: center;
  border: none;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background 0.2s;
  height: 44px;
}
.addNewBtn button{
	padding: 5px 20px;
    border-radius: 8px;
    background-color: #76E6B6;
    color: #014342;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
    line-height: 30px;
}
.qa-btn {
  border: 0;
  border-radius: 10px;
  /* padding: 10px 12px; */
  font-weight: 600;
  cursor: pointer;
  color: #fff;
  transition: transform .08s ease, box-shadow .15s ease, opacity .15s ease;
}
.qa-btn:active { transform: translateY(1px); }



/* هوفر لطيف */
.qa-btn:hover{
  box-shadow: 0 6px 18px rgba(16,24,40,.12);
  opacity: .95;
}

/* فاصل بين الشبكة وبقية العناصر */
.menu-divider{
  border: 0; height: 1px; background:#E6E8EB;
  margin: 10px -12px 8px;  /* يمدّ الخط لكامل الصندوق */
}
.user-dropdown {
  position: relative;
  margin-inline-start: 12px;
}

.user-btn {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  cursor: pointer;
  padding: 6px ;
  border-radius: 8px;
  transition: background 0.2s;
}

.user-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-inline-end: 8px;
}

.user-name {
  font-weight: 500;
  color: #fff;
  font-size: 14px;
}

.chevron {
  margin-inline-start: 6px;
  font-size: 12px;
  color: #fff;
}

.user-menu {
  position: absolute;
  top: 100%;
  inset-inline-end: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  padding: 8px 0;
  width: 180px;
  margin-top: 10px;
  z-index: 1000;
  
}

.user-menu li {
  padding: 10px 16px;
  cursor: pointer;
  color: #0F172A;
  font-size: 14px;
  display: block;
}

.user-menu li:hover {
  background: #f1f5f9;
}

.user-menu li.logout {
  color: #dc2626;
  font-weight: 600;
}
@media (max-width: 768px) {
  .logo {
    display: none;
  }

  .menu-items {
    display: none;
  }

  .menu-toggle {
    background: transparent;
    color: #fff;
    border: none;
    font-size: 40px;
    margin-inline-end: 8px;
    cursor: pointer;
    display: block;
  }
    .buttons{
      width: 100%;
    }
  .mobile-menu {
    position: absolute;
    top: 75px;
    right: 10px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    padding: 12px;
    z-index: 2000;
    width: 90vw;
    max-width: 320px;
  }

  .mobile-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .mobile-menu li {
    padding: 10px 14px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    font-size: 14px;
    color: #0F172A;
    display: block;
  }

  .mobile-menu li.logout {
    color: #dc2626;
    font-weight: bold;
  }

  .mobile-menu .badge {
    background-color: #ffd966;
    color: #000;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 6px;
    margin-inline-start: 6px;
  }

  .mobile-submenu .submenu-title {
    font-weight: 600;
    padding: 8px 14px;
    color: #333;
  }

  .quick-actions-mobile {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    padding: 8px 14px;
  }

  .quick-actions-mobile .qa-btn {
    padding: 8px 10px;
    border-radius: 10px;
    font-weight: 500;
    font-size: 13px;
    cursor: pointer;
    border: none;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/topHeader.vue